import { APPLICATION_JSON } from "@/constans";
import {
  AdapterService,
  AuthService,
  ChannelService,
  ClientService,
  CountryService,
  CurrencyService,
  DelegationService,
  DepositService,
  I18nService,
  ServicepointService,
  SolService,
  SolCustomerService,
  SubclientService,
  UserService,
  DisclaimerService,
  ReportService,
  UsersGuideService,
  SolServiceApi,
  OrderPendingService,
  ApprovalsService,
  ZoneService,
  FileImportService,
} from "@/services";
import { IStore } from "@/store";
import Vue from "vue";
import { IProvider } from "./provider.types";
import { InternalAxiosRequestConfig } from "axios";

export const provider = (): IProvider => ({
  adapter: new AdapterService(),
  auth: new AuthService(),
  client: new ClientService(),
  channel: new ChannelService(),
  country: new CountryService(),
  currency: new CurrencyService(),
  delegation: new DelegationService(),
  deposit: new DepositService(),
  i18n: new I18nService(),
  servicepoint: new ServicepointService(),
  sol: new SolService(),
  solCustomer: new SolCustomerService(),
  solServiceApi: new SolServiceApi(),
  subclient: new SubclientService(),
  user: new UserService(),
  disclaimer: new DisclaimerService(),
  usersGuide: new UsersGuideService(),
  report: new ReportService(),
  order: new OrderPendingService(),
  approvals: new ApprovalsService(),
  zone: new ZoneService(),
  fileImport: new FileImportService(),
});

export const prepareServices = (store: IStore): void => {
  store.$services = provider();

  Vue.mixin({
    beforeCreate() {
      this.$services = store.$services;
    },
  });

  const addAuthorizationBearer = async function (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> {
    const token = await store.$services.auth.getIdToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (!config.headers.Accept) {
      config.headers.Accept = APPLICATION_JSON;
    }

    return config;
  };

  Vue.$axios.interceptors.request.use(addAuthorizationBearer);

  Vue.$axiosSilent.interceptors.request.use(addAuthorizationBearer);

  Vue.$axiosSilentLoading.interceptors.request.use(addAuthorizationBearer);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const serialize = (p: any): string => {
  const searchParams = new URLSearchParams(p);
  const keysForDel: string[] = [];
  searchParams.forEach((value, key) => {
    if (value === "undefined" || !value.length) {
      keysForDel.push(key);
    }
  });

  keysForDel.forEach((key) => {
    searchParams.delete(key);
  });

  return searchParams.toString();
};
